import Helper from "../../Helper";
import { Equipment } from "../../models/Equipment";

export function getEquipmentsForProject(
    projectToken: string,
    subdomain: string = "",
    timezone: string
): Promise<Equipment[]> {
    let url = "/projects/" + projectToken + "/equipment";

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }
    return Helper.plotFetch(url)
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to get project equipments");
        })
        .then((res) => {
            return res.map((eq) => Equipment.fromApiObject(eq, timezone));
        })
        .catch(() => {
            return new Array<Equipment>();
        });
}

export function getVendorsForProject(project_token: string, subdomain: string = ""): Promise<any[]> {
    let url = "/projects/" + project_token + "/deliveries/vendors";

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return Helper.plotFetch(url)
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to get project vendors");
        })
        .then((res) => {
            return res;
        })
        .catch(() => {
            return [];
        });
}

export const uploadProjectAttachment = (
    project_token: string,
    value_id: number,
    attachment_name: string,
    attachment: File
): Promise<any> => {
    const formData = new FormData();

    formData.append("File", attachment);

    const url = "/projects/" + project_token + "/values/" + value_id + "/update_attachment";
    const options = {
        method: "post",
        body: formData,
    };
    return Helper.plotFetch(url, options).then((response) => {
        return response.json();
    });
};

export const uploadDashboardImage = (
    project_token: string,
    file: File,
    previousDashboardImageId?: number | null
): Promise<{ dashboard_image_id: number } | null> => {
    const formData = new FormData();

    formData.append("image", file);
    if (previousDashboardImageId) {
        formData.append("previous_dashboard_image_id", previousDashboardImageId.toString());
    }

    const url = "/projects/" + project_token + "/dashboard_images";
    const options = {
        method: "post",
        body: formData,
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Failed to upload dashboard image");
        })
        .catch(() => {
            return null;
        });
};

export const deleteDashboardImage = (project_token: string, dashboardImageId: number): Promise<boolean> => {
    const url = "/projects/" + project_token + "/dashboard_images/" + dashboardImageId;
    const options = {
        method: "delete",
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            return response.ok;
        })
        .catch(() => {
            return false;
        });
};
